/**
 * vuex mutation 定义
 */
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const CHANGE_DISPLAY_QUESTION = 'CHANGE_DISPLAY_QUESTION';
export const CHANGE_IS_SINGLE_PAGE = 'CHANGE_IS_SINGLE_PAGE';
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE';
export const CHANGE_JUMP_HISTORY_STACK = 'CHANGE_JUMP_HISTORY_STACK';
export const CHANGE_JUMP_QIDENTIFIER = 'CHANGE_JUMP_QIDENTIFIER';
export const CHANGE_PASS_VALIDATE = 'CHANGE_PASS_VALIDATE';
export const CHANGE_QUESTIONNAIRE_CODE = 'CHANGE_QUESTIONNAIRE_CODE';
export const CHANGE_CURRENT_PAGE_FILL_ANSWER = 'CHANGE_CURRENT_PAGE_FILL_ANSWER';
export const CHANGE_PAGE_ENV_INFO = 'CHANGE_PAGE_ENV_INFO';
export const CHANGE_HAS_SHOW_COVER_PAGE = 'CHANGE_HAS_SHOW_COVER_PAGE';
export const CHANGE_JUMP_TO_END_FLAG = 'CHANGE_JUMP_TO_END_FLAG';
export const CHANGE_APP_SHARE_FLAG = 'CHANGE_APP_SHARE_FLAG';
export const CHANGE_REWARD_CONFIG = 'CHANGE_REWARD_CONFIG';
export const CHANGE_SECACCOUNT = 'CHANGE_SECACCOUNT';

/**
 * 大数据埋点常量定义
 */
export const DB_FXAN_BTN = 'db_fxan_djdb_fxanan'; // 点击顶部-分享按钮按钮
export const DB_KAISHI_DATI = 'db_kstz_djdb_kstzan'; // 点击底部-开始挑战按钮
export const DB_LOGIN_INPUT_MOBILE = 'sjhsrk_srsjh_djsjhsrk'; // 点击手机号输入框
export const DB_LOGIN_INPUT_VERIFY = 'yzmsrk_sryzm_djyzmsrk'; // 点击验证码输入框
export const DB_LOGIN_GET_VERIFY = 'yzmhqk_hqyzm_djyzmhqk'; // 点击验证码获取框
export const DB_ON_QUESTIONNAIR = 'dt_rydt_djtmxxhdjtksrk'; // 点击题目选项或点击填空输入框
